import React from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import CategoriaDeCurriculo from 'Interface/CategoriasDeCurriculo';
import { useAdicionarCategoriaDeCurriculoMutation } from 'View/Service/Default/CategoriasDeCurriculo';

const regras = object({
  nome: string().required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const [adicionarCategoria] = useAdicionarCategoriaDeCurriculoMutation();

  const enviar = async (dados: CategoriaDeCurriculo): Promise<void> => {
    try {
      await adicionarCategoria(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/categorias-de-curriculo');
    } catch (error) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando categoria"
        descricao="Preencha o formulário e clique em enviar para adicionar a categoria"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Campo name="nome" rotulo="Nome" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink
                  tema="light"
                  to="/categorias-de-curriculo"
                  className="ms-2"
                >
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
